import * as React from "react";

const HomeIcon = (props) => (
 <svg xmlns="http://www.w3.org/2000/svg" width={props.width} height={props.height} {...props}>
 <title>{"Home"}</title>
 <path
   fill={props.fill}
   fillRule="nonzero"
   d="m8.21.5-.018.017L.137 8.471a.444.444 0 0 0-.001.64c.182.181.465.182.648.002l1.133-1.116v7.276C1.917 16.779 3.15 18 4.673 18h2.758a.45.45 0 0 0 .458-.454v-6.48h3.296v6.48c0 .254.202.454.459.454h2.68c1.523 0 2.758-1.221 2.758-2.727 0 .022-.002.012-.006-.04l-.003-.03.003-.03c.004-.043.006-.045.006-.039V7.986l1.132 1.127a.46.46 0 0 0 .647.003l.002-.003a.445.445 0 0 0 .001-.64L10.878.516l-.012-.01A1.997 1.997 0 0 0 9.538 0a1.993 1.993 0 0 0-1.327.5Zm1.327.408c.248 0 .496.089.695.257l.01.007 5.925 5.899v8.063c0-.026 0-.03.006.026l.003.032-.003.03c-.005.047-.007.061-.007.05 0 1-.828 1.82-1.84 1.82h-2.223V10.61a.45.45 0 0 0-.458-.453H7.432a.45.45 0 0 0-.459.453v6.481H4.674c-1.012 0-1.84-.82-1.84-1.82V7.09L8.84 1.16c.2-.168.45-.253.698-.253v.001Z"
 />
</svg>
);

export default HomeIcon;
